import { RSAA } from 'redux-api-middleware';
import { FETCH_ALL } from './types';

export const pairedDevicesFetchAllRequestAction = () => ({
  [RSAA]: {
    endpoint: '/v3/paired',
    method: 'GET',
    credentials: 'include',
    types: [FETCH_ALL.REQUEST, FETCH_ALL.SUCCESS, FETCH_ALL.FAILURE],
  },
});
